import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOnBoardingProcess, postOnBoardingProcess } from '../../../actions/user.action';
import validateOnboardingStep from '../../../constants/validateOnboardingStep';

// Onboarding progress is global user state, so it stays in redux. This hook is
// the wizard's only door to it: components ask "is this step visible?" and
// "complete this step" without touching the store themselves.
const useOnboarding = ({ load = false } = {}) => {
  const dispatch = useDispatch();
  const jwt = useSelector((state) => state.session.jwt);
  const { onBoarding } = useSelector((state) => state.users);

  useEffect(() => {
    if (load && jwt) {
      dispatch(getOnBoardingProcess(jwt));
    }
  }, [dispatch, load, jwt]);

  const isStepVisible = useCallback(
    (step) => (step ? validateOnboardingStep(step.value, step.previous, onBoarding || []) : false),
    [onBoarding]
  );

  const completeStep = useCallback(
    (stepValue) => {
      dispatch(postOnBoardingProcess({ steps: [...(onBoarding || []), stepValue] }, jwt));
    },
    [dispatch, onBoarding, jwt]
  );

  return { onBoarding: onBoarding || [], isStepVisible, completeStep };
};

export default useOnboarding;
